/**
 * Número de elementos por página
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  plan: { width: '15%' },
  group: { width: '15%' },
  order: { width: '10%' },
  subscriber: { width: '25%' },
  debtBalance: { width: '15%' },
  realStateTax: { width: '20%' },
};

/**
 * Opciones de filtros
 */
export const FILTER_OPTIONS = {
  ALL: { value: '', label: 'Todos' },
};